import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import { CourseFiltersValues, CourseFormValues } from "../domain/models/Course";

export const CourseFiltersFields: Fields<CourseFiltersValues> = {
    title: {
        min: 2,
        max: 255,
        placeholderKey: "console.courses.filters.title",
        type: "text",
        optional: true,
        initial: "",
    },
    shortContent: {
        min: 2,
        max: 250,
        placeholderKey: "console.courses.filters.shortContent",
        type: "text",
        optional: true,
        initial: "",
    },
    description: {
        min: 2,
        max: 1_000_000,
        placeholderKey: "console.courses.filters.description",
        type: "text",
        optional: true,
        initial: "",
    },
    author: {
        min: 2,
        max: 255,
        placeholderKey: "console.courses.filters.author",
        type: "text",
        optional: true,
        initial: "",
    },
    duration: {
        min: 1,
        max: 100,
        placeholderKey: "console.courses.filters.duration",
        type: "text",
        optional: true,
        initial: "",
    },
    topic: {
        min: 1,
        max: 255,
        placeholderKey: "console.courses.filters.topic",
        type: "text",
        optional: true,
        initial: "",
    },

    creatorId: {
        min: 1,
        max: 50,
        placeholderKey: "console.courses.table.creatorId",
        type: "text",
        optional: true,
        initial: "",
    },
};

export const CourseFields: Fields<CourseFormValues> = {
    files: {
        type: "files",
        optional: true,
        initial: [],
    },
    translations: {
        objectArray: {
            title: {
                min: 2,
                max: 255,
                placeholderKey: "console.courses.table.title",
                type: "text",
                optional: false,
                initial: "",
            },
            shortContent: {
                min: 2,
                max: 250,
                placeholderKey: "console.courses.table.shortContent",
                type: "text",
                optional: false,
                initial: "",
            },
            description: {
                min: 2,
                max: 1_000_000,
                placeholderKey: "console.courses.table.description",
                type: "richtext",
                optional: false,
                initial: "",
            },
            author: {
                min: 2,
                max: 255,
                placeholderKey: "console.courses.table.author",
                type: "text",
                optional: false,
                initial: "",
            },
            duration: {
                min: 1,
                max: 100,
                placeholderKey: "console.courses.table.duration",
                type: "text",
                optional: false,
                initial: "",
            },
            topic: {
                min: 1,
                max: 255,
                placeholderKey: "console.courses.table.topic",
                type: "text",
                optional: false,
                initial: "",
            },
            courseId: {
                type: "hidden",
                optional: true,
                initial: "",
            },
            languageCode: {
                type: "hidden",
                optional: true,
                initial: "",
            },
        },
        initial: [],
    },
};

export const courseFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, CourseFiltersFields);
};

export const courseSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, CourseFields);
};
